import React, { Component } from 'react';
import { connect } from 'react-redux';
import Desktop from './Desktop/Desktop';
import Mobile from './Mobile/Mobile';
import * as actions from '@store/actions';
import CreateEvent from '@src/createEvent';

class Header extends Component {
  state = {
    location: window.location.pathname.split('/')[1]
  };

  componentDidMount() {
    const links = document.querySelectorAll('.nav-item a, .nav-anhor');

    for (let i = 0; i < links.length; i++) {
      if (links[i].href.indexOf('#') === -1) {
        links[i].addEventListener('click', this.clickMenuHandler);
      }
    }

    setInterval(() => {
      const splited = window.location.pathname.split('/');
      if (this.state.location !== splited[1]) {
        this.setState({
          location: splited[1]
        });
      }
    }, 300);
  }

  clickMenuHandler = e => {
    const splited = e.currentTarget.getAttribute('href').split('/');
    if (this.state.location === splited[1]) {
      if (e.currentTarget.dataset.goto !== undefined) {
        const event = new CustomEvent('goto', {
          detail: {
            pageNo: parseInt(e.currentTarget.dataset.goto, 10)
          }
        });
        setTimeout(() => {
          window.dispatchEvent(event);
        }, 500);
      } else {
        const event = new CreateEvent('reload');
        setTimeout(() => {
          window.dispatchEvent(event);
        }, 500);
      }
    } else {
      this.setState({
        location: splited[1]
      });
      if (e.currentTarget.dataset.goto !== undefined) {
        const event = new CustomEvent('goto', {
          detail: {
            pageNo: parseInt(e.currentTarget.dataset.goto, 10)
          }
        });
        setTimeout(() => {
          window.dispatchEvent(event);
        }, 500);
      }
    }
  };

  render() {
    return (
      <React.Fragment>
        {this.props.pageWidth >= 992 ? (
          <Desktop
            isAuthenticated={this.props.isAuthenticated}
            logoutAction={this.props.onLogout}
          />
        ) : (
          <Mobile
            isAuthenticated={this.props.isAuthenticated}
            logoutAction={this.props.onLogout}
          />
        )}
      </React.Fragment>
    );
  }
}
const mapStateToProps = state => {
  return {
    isAuthenticated: state.auth.token !== null
  };
};
const mapDispatchToProps = dispatch => {
  return {
    onLogout: () => dispatch(actions.logout())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Header);



// WEBPACK FOOTER //
// ./src/components/Header/Header.js